var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useMemo, useRef, useState, } from 'react';
import { usePreferPersonalBooking } from '../hooks/usePreferPersonalBooking';
import { useWritableCalendars } from '../hooks/useWritableCalendars';
import { getCalendarMailboxAddress } from '../utils/utils';
import { canCreateRequestWithPersonalCalendar as resolveCanCreateRequestWithPersonalCalendar } from '../utils/canCreateRequestWithPersonalCalendar';
import { useConfig } from './ConfigContext';
import { useWatch } from 'react-hook-form';
var CalendarIntegrationsContext = createContext(null);
export var CalendarIntegrationsProvider = function (_a) {
    var _b, _c, _d;
    var children = _a.children, onError = _a.onError;
    var userContext = useConfig().userContext;
    var currentOrg = userContext.currentOrg;
    var getPreferPersonalBooking = usePreferPersonalBooking().getPreferPersonalBooking;
    var getWritableCalendars = useWritableCalendars().getWritableCalendars;
    var abortControllerRef = useRef(null);
    var onErrorRef = useRef(onError);
    onErrorRef.current = onError;
    var getPreferPersonalBookingRef = useRef(getPreferPersonalBooking);
    getPreferPersonalBookingRef.current = getPreferPersonalBooking;
    var getWritableCalendarsRef = useRef(getWritableCalendars);
    getWritableCalendarsRef.current = getWritableCalendars;
    var space = (_b = useWatch({
        name: 'spaces',
    })) === null || _b === void 0 ? void 0 : _b[0];
    var spaceCalendarType = useMemo(function () { var _a; return (_a = space === null || space === void 0 ? void 0 : space.calendar) === null || _a === void 0 ? void 0 : _a.remoteType; }, [(_c = space === null || space === void 0 ? void 0 : space.calendar) === null || _c === void 0 ? void 0 : _c.remoteType]);
    var _e = __read(useState(true), 2), isLoadingCalendarIntegration = _e[0], setIsLoadingCalendarIntegration = _e[1];
    var _f = __read(useState([]), 2), calendars = _f[0], setCalendars = _f[1];
    var _g = __read(useState(undefined), 2), selectedCalendar = _g[0], setSelectedCalendar = _g[1];
    var _h = __read(useState(false), 2), personalBookingEnabled = _h[0], setPersonalBookingEnabled = _h[1];
    var canCreateRequestWithPersonalCalendar = useMemo(function () {
        return resolveCanCreateRequestWithPersonalCalendar({
            isLoadingCalendarIntegration: isLoadingCalendarIntegration,
            personalBookingEnabled: personalBookingEnabled,
            calendarsCount: calendars.length,
            spaceCalendarType: spaceCalendarType,
            isManagedSpace: space === null || space === void 0 ? void 0 : space.isManaged,
            selectedCalendarRemoteType: selectedCalendar === null || selectedCalendar === void 0 ? void 0 : selectedCalendar.remote_type,
        });
    }, [
        isLoadingCalendarIntegration,
        personalBookingEnabled,
        calendars.length,
        spaceCalendarType,
        space === null || space === void 0 ? void 0 : space.isManaged,
        selectedCalendar === null || selectedCalendar === void 0 ? void 0 : selectedCalendar.remote_type,
    ]);
    var calendarMailboxAddress = useMemo(function () { var _a; return (_a = selectedCalendar === null || selectedCalendar === void 0 ? void 0 : selectedCalendar.mailbox_address) !== null && _a !== void 0 ? _a : getCalendarMailboxAddress(space); }, [selectedCalendar, space]);
    var calendarType = useMemo(function () { var _a, _b, _c; return (_c = (_a = selectedCalendar === null || selectedCalendar === void 0 ? void 0 : selectedCalendar.remote_type) !== null && _a !== void 0 ? _a : (_b = space === null || space === void 0 ? void 0 : space.calendar) === null || _b === void 0 ? void 0 : _b.remoteType) !== null && _c !== void 0 ? _c : ''; }, [selectedCalendar, (_d = space === null || space === void 0 ? void 0 : space.calendar) === null || _d === void 0 ? void 0 : _d.remoteType]);
    // Org preference + writable calendars only depend on the org. Do not re-run
    // when the space loads — that flipped isLoadingCalendarIntegration and made
    // ComposerBlockingAlert flash (show → hide → show).
    useEffect(function () {
        abortControllerRef.current = new AbortController();
        var signal = abortControllerRef.current.signal;
        var getCalendarConnection = function () { return __awaiter(void 0, void 0, void 0, function () {
            var preferPersonalBookingResponse, preferPersonalBooking, writableCalendarsResponse, allCalendars, error_1;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 4, 5, 6]);
                        setIsLoadingCalendarIntegration(true);
                        return [4 /*yield*/, getPreferPersonalBookingRef.current("".concat(currentOrg === null || currentOrg === void 0 ? void 0 : currentOrg.id))];
                    case 1:
                        preferPersonalBookingResponse = _c.sent();
                        if (signal.aborted)
                            return [2 /*return*/];
                        preferPersonalBooking = (_a = preferPersonalBookingResponse === null || preferPersonalBookingResponse === void 0 ? void 0 : preferPersonalBookingResponse.data) === null || _a === void 0 ? void 0 : _a.value;
                        if (!(preferPersonalBooking === 'true')) return [3 /*break*/, 3];
                        setPersonalBookingEnabled(true);
                        return [4 /*yield*/, getWritableCalendarsRef.current()];
                    case 2:
                        writableCalendarsResponse = _c.sent();
                        if (signal.aborted)
                            return [2 /*return*/];
                        allCalendars = (_b = writableCalendarsResponse === null || writableCalendarsResponse === void 0 ? void 0 : writableCalendarsResponse.data) !== null && _b !== void 0 ? _b : [];
                        setCalendars(allCalendars);
                        if (allCalendars.length > 0) {
                            setSelectedCalendar(allCalendars[0]);
                        }
                        _c.label = 3;
                    case 3: return [3 /*break*/, 6];
                    case 4:
                        error_1 = _c.sent();
                        if (!signal.aborted) {
                            onErrorRef.current("error getting calendarMailboxAddress and calendarType: ".concat(error_1));
                        }
                        return [3 /*break*/, 6];
                    case 5:
                        if (!signal.aborted) {
                            setIsLoadingCalendarIntegration(false);
                        }
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        }); };
        getCalendarConnection();
        return function () {
            var _a;
            (_a = abortControllerRef.current) === null || _a === void 0 ? void 0 : _a.abort();
        };
    }, [currentOrg === null || currentOrg === void 0 ? void 0 : currentOrg.id]);
    // Prefer a calendar whose remote_type matches the space once space is known.
    // Runs after the fetch above without toggling the loading flag.
    useEffect(function () {
        if (calendars.length === 0)
            return;
        setSelectedCalendar(function (current) {
            if (spaceCalendarType) {
                var matchingCalendars = calendars.filter(function (c) { return c.remote_type === spaceCalendarType; });
                if (matchingCalendars.length > 0) {
                    if ((current === null || current === void 0 ? void 0 : current.remote_type) === spaceCalendarType) {
                        return current;
                    }
                    return matchingCalendars[0];
                }
            }
            return current !== null && current !== void 0 ? current : calendars[0];
        });
    }, [calendars, spaceCalendarType]);
    return (_jsx(CalendarIntegrationsContext.Provider, { value: {
            calendarMailboxAddress: calendarMailboxAddress,
            calendarType: calendarType,
            canCreateRequestWithPersonalCalendar: canCreateRequestWithPersonalCalendar,
            isLoadingCalendarIntegration: isLoadingCalendarIntegration,
            spaceCalendarType: spaceCalendarType,
            calendars: calendars,
            selectedCalendar: selectedCalendar,
            setSelectedCalendar: setSelectedCalendar,
            personalBookingEnabled: personalBookingEnabled,
        }, children: children }));
};
export var useCalendarIntegrationsContext = function () {
    var context = useContext(CalendarIntegrationsContext);
    if (!context) {
        throw new Error('useCalendarIntegrationsContext must be used within a CalendarIntegrationsProvider');
    }
    return context;
};
